import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
  draggableStageWrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
  },
  stageCardContainer: {
    textDecoration: 'none',
    color: theme.palette.common.gray600,
  },
  cardWrapper: {
    position: 'relative',
    backgroundColor: theme.palette.common.white,
    borderRadius: theme.spacing(0.5),
    border: theme.customBorders.gray300,
    padding: theme.spacing(2, 1, 2, 2.5),

    '&:hover': {
      cursor: 'pointer',
      backgroundColor: theme.palette.common.gray100,
      border: theme.customBorders.gray400,
    },

    '&.selected': {
      '&:hover': {
        border: theme.customBorders.primary,
      },

      backgroundColor: theme.palette.common.blue50,

      '& .MuiIconButton-root': {
        '&:hover': {
          backgroundColor: theme.palette.common.brandSelectedHover,
        },
      },
    },
  },
  iconContainer: {
    display: 'flex',
    alignItems: 'center',
    marginRight: theme.spacing(2),
    minWidth: theme.spacing(3),
  },
  deleteContainer: {
    display: 'flex',
    alignItems: 'center',
    marginLeft: 'auto',
    paddingLeft: theme.spacing(2),
  },
  hireGoDeleteContainer: {
    // Mounting trash on hover must not move the tooltip out from under the pointer.
    '@media(max-width: 1399px)': {
      minWidth: theme.spacing(7),
      minHeight: theme.spacing(5),
    },
  },
  text: {
    color: theme.palette.common.gray800,
  },
  typeRow: {
    height: theme.spacing(2.5),
    marginBottom: theme.spacing(1),
    alignContent: 'space-around',
  },
  contentContainer: {
    minWidth: 0,
  },
  details: {},
  hireGoCard: {
    // A shared controls row leaves the narrow title its full width.
    '@media(max-width: 1399px)': {
      display: 'grid',
      gridTemplateColumns: `${theme.spacing(5)}px minmax(0, 1fr) auto`,
      '& $contentContainer, & $details, & $titleRow': {
        display: 'contents',
      },
      '& $iconContainer': {
        gridColumn: 1,
        gridRow: '1 / span 5',
      },
      '& $typeRow': {
        gridColumn: '2 / span 2',
        gridRow: 1,
      },
      '& $title': {
        gridColumn: '2 / span 2',
        gridRow: 2,
        maxWidth: '100%',
      },
      '& $titleWrapper': {
        gridColumn: '2 / span 2',
      },
      '& $labels': {
        gridColumn: 2,
        gridRow: 5,
        justifySelf: 'end',
        alignItems: 'center',
        alignSelf: 'center',
        marginTop: theme.spacing(1),
      },
      '& $deleteContainer': {
        gridColumn: 3,
        gridRow: 5,
        marginTop: theme.spacing(1),
      },
    },
  },
  // The labels sit beside the title while it keeps 45% of the row and no word
  // has to break, and move together to the next row otherwise. `width` and
  // contentContainer's `minWidth` still let a word wider than the card break.
  title: {
    flexBasis: '45%',
    flexGrow: 1,
    maxWidth: 'max-content',
    overflowWrap: 'break-word',
    width: '100%',
  },
  titleRow: {
    columnGap: theme.spacing(1),
    rowGap: theme.spacing(0.5),
  },
  labels: {
    display: 'flex',
    flexShrink: 0,
    gap: theme.spacing(1),
  },
  titleWrapper: {
    display: 'flex',
    flexDirection: 'column',
    marginTop: theme.spacing(0.75),
  },
  ruleType: {
    marginRight: theme.spacing(0.75),
    color: theme.palette.common.gray600,
  },
  type: {
    marginRight: theme.spacing(2),
    color: theme.palette.common.gray600,
  },
  applicantIcon: {
    fill: theme.palette.common.gray600,
    marginRight: theme.spacing(1),
    fontSize: theme.spacing(2),
  },
  dragIcon: {
    fill: theme.palette.common.gray500,
    fontSize: theme.spacing(1.5),
    marginTop: theme.spacing(0.5),

    '&:hover': {
      cursor: 'grab',
    },
  },
  trashCan: {
    fontSize: theme.spacing(1.5),
    fill: theme.palette.common.gray600,
  },
  calendar: {
    margin: theme.spacing(0, 1, 0, 1.5),
    fill: theme.palette.common.gray600,
    fontSize: theme.spacing(2),
  },
  ruleCardInnerContents: {
    display: 'flex',
    alignItems: 'center',
  },
  ruleStageTrashIcon: {
    height: '23px',
    width: '23px',
    marginRight: theme.spacing(1),
  },
  taskLabel: {
    backgroundColor: theme.palette.common.amber50,
    color: theme.palette.common.amber800,
    borderRadius: theme.spacing(5),
    padding: theme.spacing(0.5, 1, 0.5, 1),
    cursor: 'default',
    height: '24px',
  },
  hireGoLabel: {
    alignItems: 'center',
    backgroundColor: theme.palette.common.hireGoTint,
    borderRadius: theme.spacing(5),
    color: theme.palette.common.hireGoText,
    cursor: 'default',
    display: 'inline-flex',
    gap: theme.spacing(0.5),
    height: '24px',
    padding: theme.spacing(0.5, 1),
    whiteSpace: 'nowrap',
    '@media(max-width: 1399px)': {
      backgroundColor: 'transparent',
      padding: 0,
    },
  },
  hireGoText: {
    display: 'none',
    '@media(min-width: 1400px)': {
      display: 'inline',
    },
  },
}));
